// @flow
/** @jsx jsx */

import * as React from 'react';
import { first, isEmpty, tail } from 'lodash';

import { jsx } from '@emotion/core';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from './parts';

type Props = {
  data: Array<Array<React.Node>>,
};

/**
 * This component renders tabular data plainly in a simple table.
 */
const SimpleTable = (props: Props) => {
  const headerData = first(props.data);
  const bodyData = tail(props.data);

  const headerRow = isEmpty(headerData) ? null : (
    <TableRow key="header">
      {headerData.map((cell, i) => (
        <TableHeadCell key={i}>{cell}</TableHeadCell>
      ))}
    </TableRow>
  );
  const bodyRows = isEmpty(bodyData)
    ? null
    : bodyData.map((row, i) => (
        <TableRow key={i} row={row}>
          {row.map((cell, j) => (
            <TableCell key={j}>{cell}</TableCell>
          ))}
        </TableRow>
      ));

  return (
    (headerRow || bodyRows) && (
      <Table>
        <TableHead>{headerRow}</TableHead>
        <TableBody>{bodyRows}</TableBody>
      </Table>
    )
  );
};

export default SimpleTable;
